<script>
import { canManage } from '@utils/permissions'
import CommaFormattedNumber from 'vue-comma-formatted-number'
import { crudMethods } from '@/src/state/helpers'
import DatePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import moment from 'moment'
import CompPanjarRecon from './comp-panjar-recon'
import CompPanjarTable from './comp-panjar-table'
import CompProjectInfo from './comp-project-info'

export default {
  components: {
    CommaFormattedNumber,
    DatePicker,
    CompPanjarRecon,
    CompPanjarTable,
    CompProjectInfo,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      apiUrl: '/web/transaksi/proyek',
      title: 'Panjar',
      modalInput: false,
      modalAlert: false,
      uraian: '',
      tanggalPanjar: '',
      keterangan: '',
      ppn: 0,
      nominal: 0,
      nilaiDPP: '',
      prioritas: '',
      batch: '',
      listKali: [
        {
          value: 'volume',
          text: 'VOLUME',
        },
        {
          value: 'periode',
          text: 'PERIODE',
        },
      ],
      listSatuan: [
        {
          value: 'unit',
          text: 'UNIT',
        },
      ],
      jenisEvidence: '',
      noJustifikasiEvidence: '',
      noJustifikasiEvidence2: '',
      jenisEvidences: [
        { id: 'PO', name: 'PO' },
        { id: 'NOKES', name: 'NOKES' },
        { id: 'LAYANAN', name: 'LAYANAN' },
        { id: 'KOMTMEN', name: 'KOMTMEN' },
        { id: 'PEMBELIAN-LANGSUNG', name: 'PEMBELIAN LANGSUNG' },
        { id: 'GAJI-TKM', name: 'GAJI TKM' },
        { id: 'MOM', name: 'MOM' },
      ],
      kategories: [
        // { value: 'Barang', name: 'Barang' },
        { value: 'Barang PPn', name: 'Barang PPn' },
        { value: 'Barang non PPn', name: 'Barang non PPn' },
        { value: 'PPh 23 dan Jasa', name: 'PPh 23 dan Jasa' },
        { value: 'PPh 21', name: 'PPh 21' },
        { value: 'Lisensi', name: 'Lisensi' },
        { value: 'Operasional', name: 'Operasional' },
      ],
      noEvidence: '',
      prioritases: [],
      biayaLainLains: [],
      items: [],
      rabs: [],
      dokumens: [],
      detail: {},
      pkId: '',
      loading: false,
      dateOptions: {
        format: 'DD-MM-YYYY',
      },
      modalApproval: false,
      keteranganApproval: '',
      typeApproval: '',
      statusApproval: '',
      fileImage: null,
      tanggalTransfer: '',
      totalPanjar: '',
      totalBeban: '',
      oldTotal: 0,
      modalUpload: false,
      modalList: false,
      modalPreviewTransfer: false,
      previewTransferUrl: null,
      previewTransferType: '',
      previewTransferLoading: false,
      previewTransferError: '',
      previewTransferRequest: 0,
      modalPreview: false,
      modalPreviewPanjar: false,
      modalPreviewRecon: false,
      previewPanjar: null,
      kategori: '',
    }
  },
  computed: {
    previewTotals() {
      return this.items.reduce((totals, item) => {
        const dpp = Number(item.nilai_dpp || 0)
        const biayaLain = this.hitungBiayaLain(item.biaya_lains)
        const total = this.hitungTotalItem(item)
        const sudahKeluar = this.sumPembayaran(item.dokumens)
        totals.dpp += dpp
        totals.ppn += (dpp * Number(item.ppn || 0)) / 100
        totals.biayaLain += biayaLain
        totals.total += total
        totals.sudahKeluar += sudahKeluar
        totals.belumKeluar += total - sudahKeluar
        return totals
      }, { dpp: 0, ppn: 0, biayaLain: 0, total: 0, sudahKeluar: 0, belumKeluar: 0 })
    },
    selectedEvidenceDescriptions() {
      return [this.noJustifikasiEvidence, this.noJustifikasiEvidence2].map(
        (id) => {
          if (id === '' || id === null || id === undefined) return ''
          const option = this.rabOptions.find(
            (item) => String(item.value) === String(id)
          )
          return option ? option.text.replace(/^(> )+/, '') : ''
        }
      )
    },
    rabOptions() {
      const options = [
        { value: '', text: 'Pilih No Justifikasi Evidence' },
      ]
      const addOptions = (items, depth = 0) => {
        items.forEach((item) => {
          options.push({
            value: item.id,
            text: `${'> '.repeat(depth)}${item.id} - ${item.uraian_justifikasi}`,
          })
          if (item.subs && item.subs.length > 0) {
            addOptions(item.subs, depth + 1)
          }
        })
      }

      addOptions(this.rabs)
      return options
    },
    checkAuthorizedAll() {
      return canManage(this.user, 'transaksi.proyek.data_panjar')
    },
    checkAuthorized() {
      return canManage(this.user, 'transaksi.proyek.data_panjar')
    },
    checkValidation() {
      return (
        this.uraian === '' ||
        this.tanggalPanjar === '' ||
        this.ppn === '' ||
        this.nilaiDPP === '' ||
        this.jenisEvidence === '' ||
        this.kategori === '' ||
        this.prioritas === '' ||
        this.keterangan === ''
      )
    },
    checkValidationFile() {
      return !this.fileImage || !this.tanggalTransfer
    },
    checkValidationApproval() {
      return this.keteranganApproval === ''
    },
    total() {
      let biayaLainLains = 0
      this.biayaLainLains.forEach((item) => {
        if (item.keterangan !== '' && item.biaya !== '0') {
          biayaLainLains =
            biayaLainLains + parseInt(this.trimNominal(item.biaya))
        }
      })

      let val =
        parseInt(this.nilaiDPP.replace(/,/g, '')) +
        (parseInt(this.ppn) * parseInt(this.nilaiDPP.replace(/,/g, ''))) / 100 +
        parseInt(biayaLainLains)

      return isNaN(val) ? 0 : val
    },
  },
  watch: {
    // items: {
    //   handler: function (newVal, oldval) {
    //     for (var i = 0; i < newVal.length; i++) {
    //       this.items[i]['no'] = i + this.from
    //     }
    //   },
    //   deep: true,
    // },
  },
  beforeDestroy() {
    this.clearPreviewTransfer()
  },
  mounted() {
    this.getDetail()
    this.getList()
    this.getRabs()
    for (var i = 1; i <= 5; i++) {
      let obj = {
        value: i,
        text: i,
      }
      this.prioritases.push(obj)
    }
  },
  methods: {
    ...crudMethods,
    formatCurrency(value) {
      if (value === undefined || value === null) return 'Rp0'
      const numericValue = Math.round(Number(value))
      return (
        'Rp' + numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      )
    },
    addPanjar() {
      if (this.totalPanjar >= this.totalBeban) {
        this.modalAlert = true
      } else {
        this.clearForm()
        this.modalInput = true
      }
    },
    showModalInput() {
      this.modalAlert = false
      this.clearForm()
      this.modalInput = true
    },
    checkPanjar() {
      let biayaLainLains = 0
      this.biayaLainLains.forEach((item) => {
        if (item.keterangan !== '' && item.biaya !== '0') {
          biayaLainLains =
            biayaLainLains + parseInt(this.trimNominal(item.biaya))
        }
      })

      let total =
        parseInt(this.nilaiDPP.replace(/,/g, '')) +
        parseInt(this.nilaiDPP.replace(/,/g, '') * this.ppn) / 100 +
        parseInt(biayaLainLains)

      if (total + this.totalPanjar > this.totalBeban) {
        this.$bvModal
          .msgBoxConfirm(`Nilai panjar anda melebihi batas, tetap simpan?`, {
            title: 'Mohon Konfirmasi',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YA',
            cancelTitle: 'TIDAK',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.savePanjar()
            }
          })
      } else {
        this.savePanjar()
      }
    },
    savePanjar() {
      this.loading = true
      let biayaLainLains = []
      this.biayaLainLains.forEach((item) => {
        if (item.keterangan !== null && item.biaya !== null) {
          let obj = {
            keterangan: item.keterangan,
            biaya: item.biaya.replace(/,/g, ''),
          }

          biayaLainLains.push(obj)
        }
      })

      let body = {
        uraian: this.uraian,
        keterangan: this.keterangan,
        nilai_dpp: this.nilaiDPP.replace(/,/g, ''),
        ppn: this.ppn,
        tanggal_panjar: moment(this.tanggalPanjar, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        ),
        batch: this.batch,
        prioritas: this.prioritas,
        jenis_evidence: this.jenisEvidence,
        no_evidence: this.noEvidence,
        no_justifikasi_evidence: this.noJustifikasiEvidence,
        no_justifikasi_evidence_2: this.noJustifikasiEvidence2,
        kategori: this.kategori,
        biaya_lain_lains: biayaLainLains,
      }

      let action = 'insertData'
      let url = `${this.apiUrl}/${this.$route.params.id}/panjar`

      if (this.pkId !== '') {
        action = 'updateData'
        url = `${this.apiUrl}/${this.$route.params.id}/panjar/${this.pkId}`
      }

      this[action]({ url: url, body: body })
        .then((response) => {
          this.toast(
            'b-toaster-bottom-right',
            true,
            ' Berhasil Diupdate',
            'success'
          )
          this.loading = false

          this.getList()
          this.clearForm()
          this.modalInput = false
        })
        .catch((err) => {
          this.loading = false
          let message = JSON.parse(err.response.request.response)
          this.messageError = message.message
          this.modalError = true
        })
    },
    clearForm() {
      this.uraian = ''
      this.nilaiDPP = ''
      this.ppn = 0
      this.tanggalPanjar = ''
      this.keterangan = ''
      this.prioritas = ''
      this.batch = ''
      this.kodePanjar = ''
      this.pkId = ''
      this.noEvidence = ''
      this.noJustifikasiEvidence = ''
      this.noJustifikasiEvidence2 = ''
      this.jenisEvidence = ''
      this.biayaLainLains = []
      this.oldTotal = 0
    },
    getDetail() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data
        this.detail = data
      })
    },
    getList() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar`,
      }).then((response) => {
        const { data } = response.data
        this.items = data
        this.totalPanjar = data.reduce(
          (a, b) =>
            a +
            (b['nilai_dpp'] +
              b['biaya_lains'].reduce((x, y) => x + y['biaya'], 0) || 0),
          0
        )

      })
    },
    getRabs() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab`,
      }).then((response) => {
        const { data } = response.data
        this.rabs = data

        let items = []
        let no = 1
        data.forEach((item) => {
          let obj = {
            no: no,
            proyek_id: item.proyek_id,
            id: item.id,
            uraian_justifikasi: item.uraian_justifikasi,
            volume: item.volume,
            periode: item.periode,
            satuan: item.satuan,
            sph: item.sph,
            sph_kali: item.sph_kali,
            spk: item.spk,
            spk_kali: item.spk_kali,
            proyek_id_header: item.proyek_id_header,
            id_header: item.id_header,
            type_field: item.type_field,
          }

          if (item.subs && item.subs.length > 0) {
            const rowspanSph = item.subs.filter((x) => x.sph === null).length
            const rowspanSpk = item.subs.filter((x) => x.spk === null).length
            const rowspanVolume = item.subs.filter((x) => x.volume === null)
              .length
            const rowspanPeriode = item.subs.filter((x) => x.periode === null)
              .length
            const rowspanSatuan = item.subs.filter((x) => x.satuan === null)
              .length

            obj.rowspan_sph = rowspanSph + 1
            obj.rowspan_spk = rowspanSpk + 1
            obj.rowspan_volume = rowspanVolume + 1
            obj.rowspan_periode = rowspanPeriode + 1
            obj.rowspan_satuan = rowspanSatuan + 1
          }

          items.push(obj)

          item.subs.forEach((sub1) => {
            let obj = {
              proyek_id: sub1.proyek_id,
              id: sub1.id,
              uraian_justifikasi: sub1.uraian_justifikasi,
              volume: sub1.volume,
              periode: sub1.periode,
              satuan: sub1.satuan,
              sph: sub1.sph,
              sph_kali: sub1.sph_kali,
              spk: sub1.spk,
              spk_kali: sub1.spk_kali,
              proyek_id_header: sub1.proyek_id_header,
              id_header: sub1.id_header,
              type_field: sub1.type_field,
            }
            if (sub1.subs && sub1.subs.length > 0) {
              const rowspanSph = sub1.subs.filter((x) => x.sph === null).length
              const rowspanSpk = sub1.subs.filter((x) => x.spk === null).length
              const rowspanVolume = sub1.subs.filter((x) => x.volume === null)
                .length
              const rowspanPeriode = sub1.subs.filter((x) => x.periode === null)
                .length
              const rowspanSatuan = sub1.subs.filter((x) => x.satuan === null)
                .length

              obj.rowspan_sph = rowspanSph + 1
              obj.rowspan_spk = rowspanSpk + 1
              obj.rowspan_volume = rowspanVolume + 1
              obj.rowspan_periode = rowspanPeriode + 1
              obj.rowspan_satuan = rowspanSatuan + 1
            }

            items.push(obj)
            sub1.subs.forEach((sub2) => {
              let obj = {
                proyek_id: sub2.proyek_id,
                id: sub2.id,
                uraian_justifikasi: sub2.uraian_justifikasi,
                volume: sub2.volume,
                periode: sub2.periode,
                satuan: sub2.satuan,
                sph: sub2.sph,
                sph_kali: sub2.sph_kali,
                spk: sub2.spk,
                spk_kali: sub2.spk_kali,
                proyek_id_header: sub2.proyek_id_header,
                id_header: sub2.proyek_id,
                type_field: sub2.type_field,
              }

              if (sub2.subs && sub2.subs.length > 0) {
                const rowspanSph = sub2.subs.filter((x) => x.sph === null)
                  .length
                const rowspanSpk = sub2.subs.filter((x) => x.spk === null)
                  .length
                const rowspanVolume = sub2.subs.filter((x) => x.volume === null)
                  .length
                const rowspanPeriode = sub2.subs.filter(
                  (x) => x.periode === null
                ).length
                const rowspanSatuan = sub2.subs.filter((x) => x.satuan === null)
                  .length

                obj.rowspan_sph = rowspanSph + 1
                obj.rowspan_spk = rowspanSpk + 1
                obj.rowspan_volume = rowspanVolume + 1
                obj.rowspan_periode = rowspanPeriode + 1
                obj.rowspan_satuan = rowspanSatuan + 1
              }
              items.push(obj)
            })
          })
          no++
        })
        this.totalBeban = items.reduce(
          (a, b) =>
            a +
            (b['sph'] *
              (b['sph_kali'] !== 'all'
                ? b[b['sph_kali']]
                : b['volume'] * b['periode']) || 0),
          0
        )
      })
    },
    listDokumens(id) {
      this.getData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${id}/bukti-transfer`,
      }).then((response) => {
        const { data } = response.data
        this.dokumens = data
      })
    },
    showModalList(id) {
      this.listDokumens(id)
      this.modalList = true
    },
    showModalUpload(id) {
      this.pkId = id
      this.modalUpload = true
    },
    showModalApproval(type, status, id) {
      this.pkId = id
      this.typeApproval = type
      this.statusApproval = status
      this.modalApproval = true
    },
    approval() {
      if (!this.checkAuthorizedAll) return
      this.loading = true
      let body = {
        type: this.typeApproval,
        status: this.statusApproval,
        keterangan: this.keteranganApproval,
      }

      this.updateData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${this.pkId}/approval`,
        body: body,
      })
        .then((response) => {
          this.toast('b-toaster-bottom-right', true, ' Berhasil Diupdate')
          this.loading = false

          this.getList()
          this.keteranganApproval = ''
          this.modalApproval = false
        })
        .catch((err) => {
          this.loading = false
          let message = JSON.parse(err.response.request.response)
          this.messageError = message.message
          this.modalError = true
        })
    },
    showData(id) {
      this.pkId = id
      this.getData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${id}`,
      }).then((response) => {
        const { data } = response.data
        this.uraian = data.uraian
        this.keterangan = data.keterangan
        this.nilaiDPP = data.nilai_dpp.toString()
        this.ppn = data.ppn
        this.tanggalPanjar = moment(data.tanggal_panjar).format('DD-MM-YYYY')
        this.prioritas = data.prioritas
        this.noEvidence = data.no_evidence
        this.noJustifikasiEvidence = data.no_justifikasi_evidence
        this.noJustifikasiEvidence2 = data.no_justifikasi_evidence_2 || ''
        this.jenisEvidence = data.jenis_evidence
        this.kategori = data.kategori
        let biayaLains = []
        let totalBiayaLains = 0
        data.biaya_lains.forEach((item) => {
          let obj = {
            biaya: item.biaya.toString(),
            keterangan: item.keterangan,
          }
          biayaLains.push(obj)
          totalBiayaLains = totalBiayaLains + item.biaya
        })
        this.biayaLainLains = biayaLains

        this.oldTotal =
          parseInt(this.nilaiDPP.replace(/,/g, '')) +
          parseInt(this.nilaiDPP.replace(/,/g, '') * this.ppn) / 100 +
          parseInt(totalBiayaLains)
        this.modalInput = true
      })
    },
    handleDPP(e) {
      this.nilaiDPP = e
    },
    handleBiayaLain(e, index) {
      this.biayaLainLains[index].biaya = e
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    previewDokumenPanjar(id) {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${id}/preview`,
      }).then((response) => {
        const { data } = response.data

        let sumBiayaLain = 0
        data.biaya_lains.forEach((biayaLain) => {
          sumBiayaLain += biayaLain.biaya
        })

        data.sum_biaya_lain = sumBiayaLain
        this.previewPanjar = data
        console.log(this.previewPanjar)
        this.modalPreviewPanjar = true
      })
    },
    downloadDokumenPanjar(id) {
      this.downloadData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${id}/file`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'panjar.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    async previewBuktiTransfer(item) {
      this.clearPreviewTransfer()
      const request = this.previewTransferRequest
      this.modalPreviewTransfer = true
      this.previewTransferLoading = true
      try {
        const response = await this.downloadData({
          url: `web/transaksi/proyek/${item.proyek_id}/panjar/${item.panjar_id}/bukti-transfer/${item.id}`,
        })
        if (request !== this.previewTransferRequest) return
        if (!response) throw new Error('Dokumen tidak tersedia')
        const types = {
          pdf: 'application/pdf',
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          gif: 'image/gif',
          webp: 'image/webp',
          bmp: 'image/bmp',
        }
        const extension = (item.url || '').split('.').pop().toLowerCase()
        const type = types[extension]
        if (!type) throw new Error('Format file tidak didukung')
        this.previewTransferType = type
        this.previewTransferUrl = window.URL.createObjectURL(
          new Blob([response.data], { type })
        )
      } catch (error) {
        if (request === this.previewTransferRequest) {
          this.previewTransferError = 'Bukti transfer tidak dapat ditampilkan. Silakan coba lagi atau download file.'
        }
      } finally {
        if (request === this.previewTransferRequest) {
          this.previewTransferLoading = false
        }
      }
    },
    clearPreviewTransfer() {
      this.previewTransferRequest += 1
      if (this.previewTransferUrl) {
        window.URL.revokeObjectURL(this.previewTransferUrl)
      }
      this.previewTransferUrl = null
      this.previewTransferType = ''
      this.previewTransferError = ''
      this.previewTransferLoading = false
    },
    downloadBuktiTransfer(item) {
      this.downloadData({
        url: `web/transaksi/proyek/${item.proyek_id}/panjar/${item.panjar_id}/bukti-transfer/${item.id}`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', item.url)
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadPanjar() {
      this.downloadData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar-data`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data-panjar.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    exportPanjar() {
      this.downloadData({
        url: `web/export/panjars?proyek_id=${this.$route.params.id}`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data-panjar.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    exportPanjarIkhtisar() {
      this.downloadData({
        url: `web/export/panjar-ikhtisar?proyek_id=${this.$route.params.id}`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `data-panjar-ikhtisar-${this.detail.kode_proyek}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
      })
    },
    upload() {
      if (!this.checkAuthorizedAll) return
      if (this.checkValidationFile) return
      let body = new FormData()
      body.append('image', this.fileImage)
      body.append(
        'tanggal_transfer',
        moment(this.tanggalTransfer, 'DD-MM-YYYY').format('YYYY-MM-DD')
      )
      body.append('nominal', this.nominal)

      body.append('keterangan', this.keterangan)

      this.insertData({
        url: `web/transaksi/proyek/${this.$route.params.id}/panjar/${this.pkId}/bukti-transfer`,
        body: body,
      })
        .then((response) => {
          this.modalUpload = false
          this.fileImage = null
          this.tanggalTransfer = ''
          if (this.$refs.fileImage) this.$refs.fileImage.value = ''
          this.toast(
            'b-toaster-bottom-right',
            true,
            `Dokumen Berhasil Diupload`
          )
          this.getList()
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    dateFormat(value) {
      moment.locale('id')
      return moment(value).format('DD MMMM YYYY')
    },
    changeFile(event) {
      this.fileImage = event.target.files[0] || null
      if (!this.fileImage) return
      const validName = /\.(jpe?g|png|gif|webp|bmp|pdf)$/i.test(this.fileImage.name)
      const validType = !this.fileImage.type || /^(image\/(jpeg|png|gif|webp|bmp|x-ms-bmp)|application\/pdf)$/i.test(this.fileImage.type)
      if (!validName || !validType) {
        alert('File yang bisa diupload hanya gambar (JPG, JPEG, PNG, GIF, WEBP, BMP) dan PDF.')
        this.fileImage = null
        event.target.value = ''
        return
      }
      if (this.fileImage.size > 500 * 1024) {
        alert(
          'File yang anda upload Terlalu Besar (Maksimal 500kb) ' +
            'Ukuran File yang anda kirim ' +
            this.formatBytes(this.fileImage.size)
        )
        this.fileImage = null
        this.$refs.fileImage.value = ''
      }
    },
    removeData(id) {
      this.$bvModal
        .msgBoxConfirm(`hapus data ${this.title.toLowerCase()} ini?`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `${this.apiUrl}/${this.$route.params.id}/panjar/${id}`,
            })
              .then((response) => {
                this.getList()
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Berhasil Dihapus',
                  'success'
                )
              })
              .catch((err) => {
                let message = JSON.parse(err.response.request.response)
                this.messageError = message.message
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Tidak Dapat Dihapus',
                  'danger'
                )
              })
          }
        })
    },
    removeDokumen(item) {
      this.$bvModal
        .msgBoxConfirm('Apakah anda yakin ingin menghapus dokumen ini?', {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `web/transaksi/proyek/${item.proyek_id}/panjar/${item.panjar_id}/bukti-transfer/${item.id}`,
            })
              .then((response) => {
                const { data } = response
                if (data) {
                  this.listDokumens(item.panjar_id)
                  this.toast(
                    'b-toaster-bottom-right',
                    true,
                    ' Berhasil Dihapus'
                  )
                }
              })
              .catch((err) => {
                console.log(err)
                this.modalError = true
              })
          }
        })
    },
    addbiayaLainLains() {
      let obj = {
        keterangan: '',
        biaya: '0',
      }
      this.biayaLainLains.push(obj)
    },
    removeBiayaLainLains(item, index) {
      this.biayaLainLains.splice(index, 1)
    },
    trimNominal(str) {
      return str ? str.replace(/,/g, '') : ''
    },
    terbilang(nilai) {
      nilai = Math.abs(nilai)
      var simpanNilaiBagi = 0
      var huruf = [
        '',
        'Satu',
        'Dua',
        'Tiga',
        'Empat',
        'Lima',
        'Enam',
        'Tujuh',
        'Delapan',
        'Sembilan',
        'Sepuluh',
        'Sebelas',
      ]
      var temp = ''

      if (nilai < 12) {
        temp = ' ' + huruf[nilai]
      } else if (nilai < 20) {
        temp = this.terbilang(nilai - 10) + ' Belas'
      } else if (nilai < 100) {
        simpanNilaiBagi = Math.floor(nilai / 10)
        temp =
          this.terbilang(simpanNilaiBagi) +
          ' Puluh' +
          this.terbilang(nilai % 10)
      } else if (nilai < 200) {
        temp = ' Seratus' + this.terbilang(nilai - 100)
      } else if (nilai < 1000) {
        simpanNilaiBagi = Math.floor(nilai / 100)
        temp =
          this.terbilang(simpanNilaiBagi) +
          ' Ratus' +
          this.terbilang(nilai % 100)
      } else if (nilai < 2000) {
        temp = ' Seribu' + this.terbilang(nilai - 1000)
      } else if (nilai < 1000000) {
        simpanNilaiBagi = Math.floor(nilai / 1000)
        temp =
          this.terbilang(simpanNilaiBagi) +
          ' Ribu' +
          this.terbilang(nilai % 1000)
      } else if (nilai < 1000000000) {
        simpanNilaiBagi = Math.floor(nilai / 1000000)
        temp =
          this.terbilang(simpanNilaiBagi) +
          ' Juta' +
          this.terbilang(nilai % 1000000)
      } else if (nilai < 1000000000000) {
        simpanNilaiBagi = Math.floor(nilai / 1000000000)
        temp =
          this.terbilang(simpanNilaiBagi) +
          ' Miliar' +
          this.terbilang(nilai % 1000000000)
      } else if (nilai < 1000000000000000) {
        simpanNilaiBagi = Math.floor(nilai / 1000000000000)
        temp =
          this.terbilang(nilai / 1000000000000) +
          ' Triliun' +
          this.terbilang(nilai % 1000000000000)
      }

      return temp
    },
    formatRupiah(value) {
      // 1. Amankan jika nilainya kosong/null/undefined
      if (value === undefined || value === null || value === '') {
        return '0'
      }

      // 2. Paksa konversi tipe data apapun (termasuk String dari API) menjadi Number murni
      var numericValue = Number(value)

      // 3. Jika hasil konversinya gagal / menghasilkan NaN (Not a Number), balikkan ke '0'
      if (isNaN(numericValue)) {
        return '0'
      }

      // 4. Sekarang toFixed(0) dijamin 100% aman karena numericValue sudah pasti bertipe Number
      return numericValue
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    hitungBiayaLain(biayaLains) {
      if (!biayaLains || !Array.isArray(biayaLains)) {
        return 0
      }
      return biayaLains.reduce((total, item) => {
        return total + Number(item.biaya || 0)
      }, 0)
    },
    hitungTotalItem(item) {
      if (!item) return 0
      var dpp = Number(item.nilai_dpp || 0)
      var ppnPercent = Number(item.ppn || 0)
      var ppnNominal = (dpp * ppnPercent) / 100
      var biayaLain = this.hitungBiayaLain(item.biaya_lains || [])
      return Math.round(dpp + ppnNominal + biayaLain)
    },
    sumPembayaran(dokumens) {
      return (dokumens || []).reduce(
        (total, dokumen) => total + Number(dokumen.nominal || 0),
        0
      )
    },
    paymentStatus(item) {
      const paid = this.sumPembayaran(item.dokumens)
      if (paid === 0) return 'NOT-YET'
      return paid === this.hitungTotalItem(item) ? 'DONE' : 'PARTIAL'
    },
    paymentStatusClass(item) {
      const status = this.paymentStatus(item)
      if (status === 'DONE') return 'badge-success'
      return status === 'PARTIAL' ? 'badge-warning' : 'badge-secondary'
    },
    closeReconPreview() {
      this.getList()
      this.modalPreviewRecon = false
    },
    toast(toaster, append = false, body, variant) {
      this.$bvToast.toast(`Data ${this.title} ${body}`, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>

<template>
  <div class="row d-print-none">
    <div class="col-sm-12">
      <div class="row mb-3">
        <div class="col-sm-6">
          <h5 class="m-0 font-weight-bold text-dark">
            {{ title }}
          </h5>

          <small class="text-muted">
            Buat dan kelola panjar
            {{ detail.nama_proyek }}
          </small>
        </div>
        <div class="d-flex col-sm-6 justify-content-end gap-4">
          <b-dropdown
            text="Kelola Panjar"
            variant="outline-primary"
            class="d-flex flex-col justify-content-center align-items-center height-36-px"
            right
          >
            <!-- Tambah Panjar -->
            <b-dropdown-item v-if="checkAuthorizedAll" @click="addPanjar">
              <i class="fa fa-plus-circle mr-1"></i>
              Tambah Panjar
            </b-dropdown-item>

            <!-- Download Panjar -->
            <b-dropdown-item @click="downloadPanjar">
              <i class="fa fa-file-pdf mr-1"></i>
              Export PDF Panjar
            </b-dropdown-item>

            <!-- Preview Panjar -->
            <b-dropdown-item @click="modalPreview = true">
              <i class="fa fa-search mr-1"></i>
              Preview Panjar
            </b-dropdown-item>

            <!-- Export Panjar -->
            <b-dropdown-item @click="exportPanjar">
              <i class="fa fa-file-excel mr-1"></i>
              Export Excel Panjar
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <comp-project-info
            :detail="detail"
            :total-beban="totalBeban"
            :total-panjar="totalPanjar"
          />
        </div>
      </div>
    </div>
    <comp-panjar-table
      v-if="items && items.length > 0"
      :items="items"
      :user="user"
      :can-edit="checkAuthorizedAll"
      @download="downloadDokumenPanjar"
      @preview="previewDokumenPanjar"
      @edit="showData"
      @list="showModalList"
      @upload="showModalUpload"
      @approval="showModalApproval"
    />
    <b-modal
      v-model="modalInput"
      size="lg"
      modal-class="panjar-input-modal"
      title-class="text-center"
      :aria-label="pkId ? 'Edit Panjar' : 'Buat Panjar'"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
          <div class="panjar-form-header">
            <div>
              <h4>{{ pkId ? 'Edit Panjar' : 'Buat Panjar' }}</h4>
              <p>Lengkapi pengajuan dan referensi evidence untuk proyek ini.</p>
            </div>
            <b-button
              variant="link"
              class="panjar-close"
              aria-label="Tutup form panjar"
              @click="modalInput = false"
            ><i class="fa fa-times" aria-hidden="true"></i></b-button>
          </div>
          <div class="panjar-form-content">
            <div class="panjar-form-grid">
              <section class="panjar-form-section panjar-section-info">
                  <h5 class="panjar-section-title">Informasi Panjar</h5>
                <div class="form-group">
                  <label
                    >Tanggal<span
                      v-if="tanggalPanjar === ''"
                      class="text-danger font-size-11 font-italic"
                      >*Harus Diisi</span
                    ></label
                  >
                  <date-picker
                    id="panjar-tanggal"
                    v-model="tanggalPanjar"
                    :config="dateOptions"
                  ></date-picker>
                </div>
                <div class="form-group">
                  <label
                    >Uraian<span
                      v-if="uraian === ''"
                      class="text-danger font-size-11 font-italic"
                      >*Harus Diisi</span
                    ></label
                  >
                  <b-form-textarea
                    id="panjar-uraian"
                    v-model="uraian"
                    placeholder="Tuliskan keperluan pengajuan panjar"
                    rows="2"
                    max-rows="5"
                  ></b-form-textarea>
                </div>
                </section>
              <section class="panjar-form-section panjar-section-costs">
                  <h5 class="panjar-section-title">Rincian Biaya</h5>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label
                      >Nilai DPP<span
                        v-if="nilaiDPP === ''"
                        class="text-danger font-size-11 font-italic"
                        >*Harus Diisi</span
                      ></label
                    >
                    <comma-formatted-number
                      :format-options="{ thousand: ',', precision: 0 }"
                      :value="nilaiDPP"
                      class="form-control"
                      @input="handleDPP"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>PPN (%)</label>
                    <input
                      v-model="ppn"
                      type="text"
                      class="form-control"
                      @keypress="onlyNumber"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="d-flex justify-content-between align-items-center">
                    <label>Biaya Lain-lain</label>
                    <button class="btn-add-biaya" @click="addbiayaLainLains"
                      >Tambah <i class="fa fa-plus-circle"></i
                    ></button>
                  </div>
                  <div class="panjar-cost-table">
                  <table class="table table-sm table-biaya">
                    <thead>
                      <tr>
                        <th class="text-left">Keterangan</th>
                        <th class="text-left">Biaya</th>
                        <th>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="biayaLainLains.length === 0">
                        <td colspan="3" class="panjar-empty-cost">
                          Belum ada biaya tambahan.
                        </td>
                      </tr>
                      <tr v-for="(item, index) in biayaLainLains" :key="index">
                        <td>
                          <input
                            v-model="item.keterangan"
                            placeholder="Keterangan biaya"
                            :aria-label="`Keterangan biaya tambahan ${index + 1}`"
                            class="form-control"
                          />
                        </td>
                        <td>
                          <comma-formatted-number
                            :format-options="{ thousand: ',', precision: 0 }"
                            :value="item.biaya"
                            :aria-label="`Nominal biaya tambahan ${index + 1}`"
                            class="form-control"
                            @input="handleBiayaLain($event, index)"
                          />
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            :aria-label="`Hapus biaya tambahan ${index + 1}`"
                            @click="removeBiayaLainLains(item, index)"
                            ><i class="fa fa-trash"></i
                          ></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
                <div class="panjar-total">
                  <label for="panjar-total">Total Pengajuan <small>Termasuk PPN dan biaya lain-lain</small></label>
                  <input
                    id="panjar-total"
                    readonly
                    :value="total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    type="text"
                    class="form-control"
                    @keypress="onlyNumber"
                  />
                </div>
                </section>
              <section class="panjar-form-section panjar-section-evidence">
                  <h5 class="panjar-section-title">Evidence &amp; Kategori</h5>
                <div class="row">
                  <div class="form-group col-12">
                    <label
                      >Evidence<span
                        v-if="jenisEvidence === ''"
                        class="text-danger font-size-11 font-italic"
                        >*Harus Dipilih</span
                      ></label
                    >
                    <b-form-select
                      v-model="jenisEvidence"
                      :options="jenisEvidences"
                      value-field="id"
                      text-field="name"
                    >
                    </b-form-select>
                  </div>
                  <div class="form-group col-12">
                    <label
                      >Kategori
                      <span
                        v-if="kategori === ''"
                        class="text-danger font-size-11 font-italic"
                      >
                        *Harus Dipilih
                      </span>
                    </label>
                    <b-form-select
                      v-model="kategori"
                      :options="kategories"
                      value-field="value"
                      text-field="name"
                    >
                    </b-form-select>
                  </div>
                </div>
                <div class="panjar-evidence-group">
                  <p class="panjar-field-hint">Pilih referensi justifikasi dari RAB proyek.</p>
                <div class="form-group">
                  <label for="panjar-justifikasi-1">No Justifikasi Evidence 1</label>
                  <b-form-select
                    id="panjar-justifikasi-1"
                    v-model="noJustifikasiEvidence"
                    :options="rabOptions"
                  >
                  </b-form-select>
                  <p v-if="selectedEvidenceDescriptions[0]" class="panjar-evidence-description">
                    {{ selectedEvidenceDescriptions[0] }}
                  </p>
                </div>
                <div class="form-group">
                  <label for="panjar-justifikasi-2">No Justifikasi Evidence 2 <span class="panjar-optional">Opsional</span></label>
                  <b-form-select
                    id="panjar-justifikasi-2"
                    v-model="noJustifikasiEvidence2"
                    :options="rabOptions"
                  >
                  </b-form-select>
                  <p v-if="selectedEvidenceDescriptions[1]" class="panjar-evidence-description">
                    {{ selectedEvidenceDescriptions[1] }}
                  </p>
                </div>
                </div>
                </section>
              <section class="panjar-form-section panjar-section-notes">
                  <h5 class="panjar-section-title">Catatan Pengajuan</h5>
                <div class="form-group">
                  <label
                    >Prioritas<span
                      v-if="prioritas === ''"
                      class="text-danger font-size-11 font-italic"
                      >*Harus Dipilih</span
                    ></label
                  >
                  <b-form-select v-model="prioritas" :options="prioritases">
                  </b-form-select>
                </div>
                <div class="form-group">
                  <label
                    >Keterangan<span
                      v-if="keterangan === ''"
                      class="text-danger font-size-11 font-italic"
                      >*Harus Diisi</span
                    ></label
                  >
                  <b-form-textarea
                    id="panjar-keterangan"
                    v-model="keterangan"
                    placeholder="Tuliskan keterangan yang akan tampil di dokumen panjar"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                  <p class="panjar-field-hint">Keterangan ini ditampilkan di dokumen panjar.</p>
                </div>
                </section>
            </div>
          </div>
          <div class="panjar-form-footer">
            <span class="panjar-field-hint">Lengkapi kolom wajib untuk menyimpan panjar.</span>
            <div class="panjar-form-actions">
            <b-button
              class="mr-2"
              type="button"
              variant="outline-primary"
              @click="modalInput = false"
              >Batal</b-button
            >
            <b-button
              type="button"
              variant="primary"
              :disabled="checkValidation"
              @click="checkPanjar"
              >Simpan Panjar</b-button
            >
            </div>
          </div>
        </b-modal>
    <b-modal
      v-model="modalApproval"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label
              >Catatan<span
                v-if="keteranganApproval === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <b-form-textarea
              id="textarea"
              v-model="keteranganApproval"
              rows="3"
              max-rows="3"
              no-resize
            ></b-form-textarea>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalApproval = false"
          >Batal / Keluar</b-button
        >
        <b-button
          type="button"
          variant="primary"
          :disabled="checkValidationApproval"
          @click="approval"
          >SIMPAN</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalUpload"
      size=""
      title-class="text-center"
      centered
      no-close-on-backdrop
      title="Upload Dokumen"
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label
              >Bukti Transfer<span
                v-if="!fileImage"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <input
              id="fileImage"
              ref="fileImage"
              class="form-control"
              type="file"
              accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf"
              @change="changeFile"
            />
            <small class="form-text text-muted">
              File yang bisa diupload: gambar (JPG, JPEG, PNG, GIF, WEBP, BMP) dan PDF. Maksimal 500 KB.
            </small>
          </div>
          <div class="form-group col-sm-12">
            <label
              >Nominal<span
                v-if="nominal === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >

            <vue-numeric
              v-model="nominal"
              currency="Rp"
              separator=","
              class="form-control"
            ></vue-numeric>
          </div>
          <div class="form-group col-sm-12">
            <label
              >Tgl. Transfer<span
                v-if="tanggalTransfer === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <date-picker
              v-model="tanggalTransfer"
              :config="{
                format: 'DD-MM-YYYY',
              }"
            ></date-picker>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="modalUpload = false"
          >Close</b-button
        >
        <button
          type="button"
          class="btn btn-primary btn-sm p-2 ml-2 pl-4 pr-4"
          :disabled="checkValidationFile"
          @click="upload"
        >
          <i class="uil uil-edit mr-1"></i>Upload
        </button>
      </template>
    </b-modal>
    <b-modal
      v-model="modalList"
      size=""
      title-class="text-center"
      centered
      no-close-on-backdrop
      :title="`List Bukti Transfer`"
    >
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>No</th>
                <th>Nominal</th>
                <th>Tgl. Dokumen</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dokumens" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ formatCurrency(item.nominal) }}</td>
                <td class="text-center">{{
                  dateFormat(item.tanggal_dokumen)
                }}</td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-info mr-1"
                    title="Preview bukti transfer"
                    aria-label="Preview bukti transfer"
                    @click="previewBuktiTransfer(item)"
                    ><i class="fa fa-eye"></i
                  ></button>
                  <button
                    class="btn btn-sm btn-primary mr-1"
                    @click="downloadBuktiTransfer(item)"
                    ><i class="fa fa-download"></i
                  ></button>
                  <button
                    v-if="checkAuthorizedAll"
                    class="btn btn-sm btn-danger"
                    @click="removeDokumen(item)"
                    ><i class="fa fa-trash"></i
                  ></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="modalList = false"
          >Close</b-button
        >
      </template>
    </b-modal>
    <b-modal
      v-model="modalPreviewTransfer"
      size="xl"
      centered
      title="Preview Bukti Transfer"
      hide-footer
      @hidden="clearPreviewTransfer"
    >
      <div v-if="previewTransferLoading" class="text-center py-5" role="status">
        Memuat bukti transfer...
      </div>
      <div v-else-if="previewTransferError" class="alert alert-danger" role="alert">
        {{ previewTransferError }}
      </div>
      <template v-else-if="previewTransferUrl">
        <iframe
          v-if="previewTransferType === 'application/pdf'"
          :src="previewTransferUrl"
          title="Preview PDF bukti transfer"
          style="width: 100%; height: 75vh; border: 0"
        ></iframe>
        <div v-else class="text-center">
          <img
            :src="previewTransferUrl"
            alt="Bukti transfer"
            style="max-width: 100%; max-height: 75vh; object-fit: contain"
            @error="previewTransferError = 'Gambar bukti transfer tidak dapat ditampilkan.'"
          />
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalPreview"
      size="xl"
      title-class="text-center"
      centered
      no-close-on-backdrop
      title="Preview Panjar"
      modal-class="modal-print"
    >
      <h4 class="header-margin font-weight-bold"
        ><center
          >Panjar {{ detail.kode_proyek }} {{ detail.nama_proyek }}</center
        ></h4
      >

      <comp-project-info
        :detail="detail"
        :total-beban="totalBeban"
        :total-panjar="totalPanjar"
      />
      <div class="table-responsive panjar-report-preview">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th rowspan="2">No</th><th rowspan="2">Tanggal</th><th rowspan="2">Uraian</th>
              <th colspan="4">Jumlah (Rp)</th><th colspan="3">Pembayaran</th>
              <th rowspan="2">Kategori</th><th rowspan="2">KET</th>
            </tr>
            <tr>
              <th>Nilai DPP</th><th>PPN (%)</th><th>Biaya Lain</th><th>Nilai Total</th>
              <th>Total Pembayaran</th><th>Selisih</th><th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="item.id">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-nowrap">{{ dateFormat(item.tanggal_panjar) }}</td>
              <td>Pjr {{ item.proyek ? item.proyek.kode_proyek : '' }} {{ item.uraian }} ({{ item.batch }})</td>
              <td class="text-right text-nowrap">{{ formatCurrency(item.nilai_dpp) }}</td>
              <td class="text-center">{{ item.ppn }}%</td>
              <td class="text-right text-nowrap">{{ formatCurrency(hitungBiayaLain(item.biaya_lains)) }}</td>
              <td class="text-right text-nowrap font-weight-bold">{{ formatCurrency(hitungTotalItem(item)) }}</td>
              <td class="text-right text-nowrap">{{ formatCurrency(sumPembayaran(item.dokumens)) }}</td>
              <td class="text-right text-nowrap">{{ formatCurrency(hitungTotalItem(item) - sumPembayaran(item.dokumens)) }}</td>
              <td class="text-center"><span class="badge" :class="paymentStatusClass(item)">{{ paymentStatus(item) }}</span></td>
              <td>{{ item.kategori || '-' }}</td>
              <td style="white-space: pre-line;">{{ item.keterangan }}</td>
            </tr>
            <tr v-if="items.length === 0"><td colspan="12" class="text-center text-muted">Belum ada data panjar.</td></tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold bg-light">
              <td colspan="3">TOTAL</td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.dpp) }}</td>
              <td></td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.biayaLain) }}</td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.total) }}</td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.sudahKeluar) }}</td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.belumKeluar) }}</td>
              <td colspan="3"></td>
            </tr>
            <tr>
              <td colspan="6">Sisa Beban Vendor Setelah PPN</td>
              <td class="text-right text-nowrap">{{ formatCurrency(Number(totalBeban || 0) - previewTotals.total) }}</td>
              <td colspan="5"></td>
            </tr>
            <tr>
              <td colspan="6">Nilai Panjar Sebelum PPN</td>
              <td class="text-right text-nowrap">{{ formatCurrency(previewTotals.dpp + previewTotals.biayaLain) }}</td>
              <td colspan="5"></td>
            </tr>
            <tr>
              <td colspan="6">Sisa Beban Vendor Sebelum PPN</td>
              <td class="text-right text-nowrap">{{ formatCurrency(Number(totalBeban || 0) - previewTotals.dpp - previewTotals.biayaLain) }}</td>
              <td colspan="5"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <template v-slot:modal-footer>
        <a href="javascript:window.print()" class="btn btn-primary">
          <i class="uil uil-print mr-1"></i> Print
        </a>
      </template>
    </b-modal>
    <b-modal
      v-model="modalPreviewPanjar"
      size="xl"
      title-class="text-center"
      centered
      no-close-on-backdrop
      title="Preview Panjar"
      modal-class="modal-print"
    >
      <div v-if="previewPanjar !== null" class="row justify-content-center">
        <div class="col-sm-10">
          <table class="table-panjar">
            <tr>
              <td colspan="3">
                <img
                  src="@assets/images/smart-media.png"
                  style="width: 25%"
                  class="img-fluid"
                />
              </td>
            </tr>
          </table>

          <table class="table-panjar">
            <tbody>
              <tr class="text-center">
                <td
                  colspan="3"
                  class="line-height-25 font-size-30 font-weight-bold"
                  >PANJAR PROJECT</td
                >
              </tr>
              <tr class="text-center">
                <td
                  colspan="3"
                  class="line-height-25 font-size-24 font-weight-bold"
                  >{{ previewPanjar.proyek.nama_proyek }}</td
                >
              </tr>
            </tbody>
          </table>
          <hr class="border-bottom" />
          <table class="table-panjar">
            <tbody>
              <tr>
                <td>Telah Terima Dari</td>
                <td>:</td>
                <td class="padding-left-5"
                  >Bendahara KOPERASI JASA KARYAWAN SMART MEDIA</td
                >
              </tr>
              <tr>
                <td>Nilai DPP + PPN 11%</td>
                <td>:</td>
                <td class="padding-left-5"
                  >Rp
                  {{
                    (
                      previewPanjar.nilai_dpp +
                      (previewPanjar.nilai_dpp * previewPanjar.ppn) / 100
                    )
                      .toFixed()
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }}
                </td>
              </tr>
              <tr
                v-for="(biayaLain, index) in previewPanjar.biaya_lains"
                :key="index"
              >
                <td>{{ biayaLain.keterangan }}</td>
                <td>:</td>
                <td class="padding-left-5">
                  Rp{{
                    biayaLain.biaya
                      .toFixed()
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }}
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td>:</td>
                <td class="padding-left-5"
                  >Rp
                  {{
                    (
                      previewPanjar.nilai_dpp +
                      (previewPanjar.nilai_dpp * previewPanjar.ppn) / 100 +
                      previewPanjar.sum_biaya_lain
                    )
                      .toFixed()
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }}
                </td>
              </tr>
              <tr>
                <td>Dengan Huruf</td>
                <td>:</td>
                <td class="padding-left-5">
                  {{
                    terbilang(
                      (
                        previewPanjar.nilai_dpp +
                        (previewPanjar.nilai_dpp * previewPanjar.ppn) / 100 +
                        previewPanjar.sum_biaya_lain
                      ).toFixed()
                    )
                  }}
                  Rupiah
                </td>
              </tr>
              <tr>
                <td>Untuk Keperluan</td>
                <td>:</td>
                <td class="padding-left-5"
                  >Pjr
                  {{ previewPanjar.proyek.kode_proyek }}
                  {{ previewPanjar.proyek.nama_proyek }}
                  {{ previewPanjar.uraian }}
                  ({{ previewPanjar.batch }})
                </td>
              </tr>
              <tr>
                <td>No. Justifikasi Evidence 1</td>
                <td>:</td>
                <td class="padding-left-5">
                  {{ previewPanjar.no_justifikasi_evidence }}
                  <span
                    v-if="previewPanjar.rab_justifikasi_evidence"
                  >
                    - {{ previewPanjar.rab_justifikasi_evidence.uraian_justifikasi }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>No. Justifikasi Evidence 2</td>
                <td>:</td>
                <td class="padding-left-5">
                  {{ previewPanjar.no_justifikasi_evidence_2 }}
                  <span v-if="previewPanjar.rab_justifikasi_evidence2">
                    - {{ previewPanjar.rab_justifikasi_evidence2.uraian_justifikasi }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>Kategori</td>
                <td>:</td>
                <td class="padding-left-5">{{ previewPanjar.kategori }}</td>
              </tr>
              <tr>
                <td>Jangka Waktu & Tanggal</td>
                <td>:</td>
                <td class="padding-left-5">
                  {{ dateFormat(previewPanjar.tanggal_panjar) }}
                </td>
              </tr>
              <tr>
                <td>Batas Waktu Pembayaran</td>
                <td>:</td>
                <td class="padding-left-5">
                  PRIORITAS {{ previewPanjar.prioritas }}
                </td>
              </tr>
              <tr>
                <td>Keterangan</td>
                <td>:</td>
                <td
                  class="padding-left-5"
                  style="white-space: pre-line; overflow-wrap: break-word;"
                >{{ previewPanjar.keterangan }}</td>
              </tr>
              <tr>
                <td>Tanggal Pertanggungan*)</td>
                <td>:</td>
                <td class="padding-left-5"></td>
              </tr>
              <tr>
                <td colspan="3">
                  *) Pengembalian panjar menunggu pembayaran dari pemberi
                  pekerjaan
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-panjar">
            <tr class="text-right">
              <td>Surabaya, {{ dateFormat(previewPanjar.tanggal_panjar) }}</td>
            </tr>
          </table>

          <table class="table-panjar">
            <tr class="text-center">
              <td>Setuju untuk dibayarkan, Bendahara</td>
              <td class="th-td-width-40"></td>
              <td>Pengambil Panjar</td>
            </tr>
            <tr>
              <td colspan="3" class="padding-bottom-150"></td>
            </tr>
            <tr class="text-center">
              <td class="text-uppercase font-weight-bold"
                ><u>{{
                  previewPanjar.status_bendahara === 'DITERIMA'
                    ? previewPanjar.bendahara
                    : ''
                }}</u></td
              >
              <td></td>
              <td class="text-uppercase font-weight-bold"
                ><u>{{
                  previewPanjar.status_sekretaris === 'DITERIMA'
                    ? previewPanjar.manager
                    : ''
                }}</u></td
              >
            </tr>
          </table>

          <table class="table-panjar">
            <tr class="text-center">
              <td class="line-height-15">Mengetahui dan Menyetujui:</td>
            </tr>
            <tr class="text-center">
              <td class="text-uppercase font-weight-bold">KETUA</td>
            </tr>
            <tr>
              <td colspan="3" class="padding-bottom-150"></td>
            </tr>
            <tr class="text-center">
              <td class="text-uppercase font-weight-bold"
                ><u>{{
                  previewPanjar.status_ketua === 'DITERIMA'
                    ? previewPanjar.ketua
                    : ''
                }}</u></td
              >
            </tr>
          </table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <a href="javascript:window.print()" class="btn btn-primary">
          <i class="uil uil-print mr-1"></i> Print
        </a>
      </template>
    </b-modal>
    <b-modal
      v-model="modalAlert"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div
        class="d-flex flex-column align-items-center justify-content-center gap-20 margin-bottom-30"
      >
        <i class="fas fa-exclamation-triangle text-danger fa-6x"></i>
        <div
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <h6 class="m-0 font-size-20">Panjar Anda Melebihi SPH </h6>
          <h6 class="m-0 font-size-20">Apakah anda ingin melanjutkan?</h6>
        </div>
      </div>

      <div class="d-flex gap-5 align-items-center">
        <button
          class="btn width-50 font-size-15 font-weight-500 btn-primary"
          @click="modalAlert = false"
        >
          Tidak
        </button>
        <button
          class="btn width-50 font-size-15 font-weight-500 btn-danger"
          @click="showModalInput"
          >Ya, Lanjutkan</button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalPreviewRecon"
      size="lg"
      hide-footer
      title="Upload Dokumen Rekonsiliasi"
      centered
    >
      <comp-panjar-recon
        v-if="modalPreviewRecon"
        :id-proyek="this.$route.params.id"
        @success-store="closeReconPreview"
      />
    </b-modal>
  </div>
</template>
<style lang="scss">
.panjar-report-preview {
  th {
    text-align: center;
    vertical-align: middle;
    background: #f1f5f9;
  }

  tr:first-child th:nth-child(3),
  th:last-child {
    min-width: 200px;
  }

  @media print {
    overflow: visible;

    th,
    td {
      min-width: 0 !important;
      padding: 3px;
      font-size: 9px;
      white-space: normal !important;
    }

    tfoot {
      display: table-row-group;
    }
  }
}

.table-middle {
  tr {
    td {
      line-height: 17px;
    }
  }
}
.danger-panjar {
  background-color: #dc3545;
  color: #fff;
}
.panjar-input-modal {
  .modal-dialog {
    max-width: 1040px;
    margin-right: auto;
    margin-left: auto;
  }

  .modal-content {
    overflow: hidden;
    border: 0;
    border-radius: 12px;
  }

  .modal-body {
    max-height: calc(100vh - 64px);
    overflow-y: auto;
    padding: 0;
    background: #f5f7fb;
  }

  .panjar-form-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px 28px;
    background: #fff;
    border-bottom: 1px solid #e5e9f0;

    h4 {
      margin: 0 0 6px;
      font-size: 21px;
      font-weight: 600;
      color: #253858;
    }

    p {
      margin: 0;
      color: #64748b;
    }
  }

  .panjar-close {
    padding: 4px 8px;
    color: #64748b;
  }

  .panjar-form-content {
    padding: 24px 28px 4px;
  }

  .panjar-form-grid {
    display: grid;
    grid-template-areas: 'info' 'costs' 'evidence' 'notes';
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
    margin-bottom: 20px;
  }

  .panjar-section-info {
    grid-area: info;
  }

  .panjar-section-costs {
    grid-area: costs;
  }

  .panjar-section-evidence {
    grid-area: evidence;
  }

  .panjar-section-notes {
    grid-area: notes;
  }

  @media (min-width: 992px) {
    .panjar-form-grid {
      grid-template-areas: 'info evidence' 'costs notes';
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .panjar-form-section {
    min-width: 0;
    padding: 20px;
    margin: 0;
    background: #fff;
    border: 1px solid #e5e9f0;
    border-radius: 10px;
  }

  .panjar-section-title {
    margin: 0 0 18px;
    font-size: 15px;
    font-weight: 600;
    color: #253858;
  }

  label {
    display: block;
    margin-bottom: 7px;
    font-weight: 500;
    color: #334155;

    .text-danger {
      margin-left: 5px;
      font-style: normal !important;
    }
  }

  .form-group {
    margin-bottom: 18px;
  }

  .form-control,
  .custom-select {
    min-height: 40px;
    border-color: #d8e0eb;
    border-radius: 6px;
  }

  .panjar-field-hint {
    margin: 7px 0 0;
    font-size: 12px;
    line-height: 1.6;
    color: #64748b;
  }

  .panjar-evidence-group {
    padding-top: 14px;
    border-top: 1px solid #edf0f5;

    > .panjar-field-hint {
      margin: 0 0 14px;
    }
  }

  .panjar-optional {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 400;
    color: #64748b;
  }

  .panjar-evidence-description {
    padding: 10px 12px;
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 1.6;
    overflow-wrap: anywhere;
    color: #475569;
    background: #f5f7fb;
    border-left: 3px solid #b6c8e7;
    border-radius: 4px;
  }

  .btn-add-biaya {
    padding: 5px 8px;
    margin-bottom: 7px;
    font-size: 12px;
    color: #325da8;
    background: #edf3ff;
    border: 1px solid #d7e3fa;
    border-radius: 5px;
  }

  .panjar-cost-table {
    overflow-x: auto;
    border: 1px solid #e5e9f0;
    border-radius: 6px;
  }

  .table {
    margin-bottom: 0;

    th {
      padding: 9px;
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
      background: #f8fafc;
      border-top: 0;
      border-bottom: 1px solid #e5e9f0;
    }

    td {
      padding: 8px;
      vertical-align: middle;
    }

    th:nth-child(2) {
      width: 34%;
    }

    th:last-child {
      width: 50px;
    }

    .form-control {
      min-width: 100px;
    }

    .panjar-empty-cost {
      padding: 20px 12px;
      font-size: 12px;
      text-align: center;
      color: #64748b;
    }
  }

  .panjar-total {
    padding: 16px;
    background: #eef4ff;
    border: 1px solid #dbe6fa;
    border-radius: 8px;

    label small {
      display: block;
      margin-top: 3px;
      font-size: 11px;
      color: #64748b;
    }

    input {
      height: auto;
      padding: 0;
      font-size: 24px;
      font-weight: 600;
      color: #274e87;
      background: transparent;
      border: 0;
    }
  }

  .panjar-form-footer {
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 28px;
    background: #fff;
    border-top: 1px solid #e5e9f0;

    .panjar-field-hint {
      margin: 0 16px 0 0;
    }
  }

  .panjar-form-actions {
    display: flex;
    flex-shrink: 0;

    .btn {
      min-height: 40px;
      padding-right: 20px;
      padding-left: 20px;
      border-radius: 6px;
    }
  }

  @media (max-width: 575.98px) {
    .modal-dialog {
      margin: 8px;
    }

    .modal-body {
      max-height: calc(100vh - 16px);
    }

    .panjar-form-header,
    .panjar-form-content,
    .panjar-form-footer {
      padding: 16px;
    }

    .panjar-form-section {
      padding: 16px;
    }

    .panjar-form-footer {
      flex-direction: column;
      align-items: stretch;

      .panjar-field-hint {
        margin: 0 0 10px;
      }
    }

    .panjar-form-actions .btn {
      flex: 1;
    }
  }
}
</style>
